if (!customElements.get('jhp-review-banner')) {
  customElements.define('jhp-review-banner', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.video.muted = true;
      this.sync = () => {
        if (this.motion.matches || !this.visible || document.hidden) {
          this.video.pause();
        } else {
          // Keep the poster visible if the browser declines autoplay.
          this.video.play().catch(() => {});
        }
      };
      this.motion.addEventListener('change', this.sync);
      document.addEventListener('visibilitychange', this.sync);
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
      this.sync();
    }
    disconnectedCallback() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.video.pause();
      this.motion.removeEventListener('change', this.sync);
      document.removeEventListener('visibilitychange', this.sync);
    }
  });
}
